import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';

const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/text',
    'Cache-Control': 'no-cache',
    Pragma: 'no-cache',
    Expires: 'Sat, 01 Jan 2000 00:00:00 GMT',
  }),
  responseType: 'text' as 'json',
};

@Injectable({ providedIn: 'root' })
export class StartClient {
  private bedomningsPortalUrl = environment.bedomningsPortalApiUrl;

  constructor(private http: HttpClient) {}

  public getEnvironmentInfoText(): Observable<string> {
    const url = `${this.bedomningsPortalUrl}/start/getserverdata`;

    return this.http.get<string>(url, httpOptions);
  }
}
